import { createContext } from "react";

const ChannelContext = createContext();

export { ChannelContext };
